<!--
/*******************************************************************************
*@ 컴포넌트명   : TrsaccRsultInqDtlRpt2.vue
*@ 컴포넌트설명 : 자동이체 - 이체 상세내용
*@ 사용전문     :  
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <section class="transfer">
    <popup
      :opened.sync="openData"
      :use-header="true"
      :use-footer="true"
      class="popup"
      @cancel="popupClose"
    >
      <template #subtitle>
        <h2>{{ /*이체 상세 내용*/ $t("MPAY-04-01-12-01") }}</h2>
      </template>
      <template #content>
        <div class="divider">
          <span
            class="divider-date"
          >{{ /* 이체 일시 */ $t("MPAY-04-01-06-A2") }} : {{ $getGlobalDateFmt(detailInfo.sysLastPrcssYMS) }}</span>
        </div>
        <div class="cont-tit">
          <h6>{{ /* 이체 결과 */ $t("MPAY-04-01-12-03") }}</h6>
        </div>
        <dl class="dlist dlist-item--type6">
          <dt>{{ /* 이체 구분 */ $t("MPAY-04-01-12-04") }}</dt>
          <dd class="right">{{ /* 자동 이체 */ $t("MPAY-04-01-04-09") }}</dd>
          <dt>{{ /* 이체 일시 */ $t("MPAY-04-01-06-A2") }}</dt>
          <dd class="right">{{ $getGlobalDateFmt(detailInfo.sysLastPrcssYMS) }}</dd>
          <dt>{{ /* 처리 결과 */ $t("MPAY-04-01-12-06") }}</dt>
          <dd class="right">{{ $t(`${detailInfo.rsultCd}_이체결과코드`) }}</dd>
          <dt>{{ /* 오류발생코드 */ $t("MPAY-04-01-12-20") }}</dt>
          <dd class="right">{{ detailInfo.iOBrncoErrMsgCd }}</dd>
        </dl>
        <div class="cont-tit">
          <h6>{{ /* 출금 정보 */ $t("MPAY-04-01-12-09") }}</h6>
        </div>
        <dl class="dlist dlist-item--type6">
          <dt>{{ /*출금 계좌 번호*/ $t("MPAY-04-01-12-10") }}</dt>
          <dd class="right">{{ detailInfo.acno }}</dd>
          <dt>{{ /*출금 금액*/ $t("MPAY-01-01-14-10") }}</dt>
          <dd class="right">
            <span class="exchange-unit">{{ detailInfo.cncycd }}</span>
            <span class="amount">{{ detailInfo.trsaccAmt }}</span>
          </dd>
          <dt>{{ /*송금메모*/ $t("MINQ-02-02-03-13") }}</dt>
          <dd class="right">{{ detailInfo.trsaccApctRefCtnt1 }}</dd>
        </dl>
        <div class="cont-tit">
          <h6>{{ /*입금정보*/ $t("MPAY-04-01-12-14") }}</h6>
        </div>
        <dl class="dlist dlist-item--type6">
          <template v-if="!_.isEmpty(detailInfo.rcevnBnkName)">
            <dt>{{ /* 은행명 */ $t("MPAY-04-01-07-09") }}</dt>
            <dd class="right">{{ detailInfo.rcevnBnkName }}</dd>
          </template>
          <dt>{{ /*입금 계좌번호*/ $t("MPAY-04-01-12-15") }}</dt>
          <dd class="right">{{ detailInfo.draweAcno }}</dd>
          <dt>{{ /* 입금 금액 */ $t("MPAY-04-01-12-16") }}</dt>
          <dd class="right">
            <span class="exchange-unit">{{ detailInfo.cncycd }}</span>
            <span class="amount">{{ $num(detailInfo.trsaccAmt) }}</span>
          </dd>
          <dt>{{ /*수취인*/ $t("MPAY-04-01-12-17") }}</dt>
          <dd class="right">{{ detailInfo.draweAcnFname }}</dd>
          <dt>{{ /*Particulars*/ /*수취인 참조내용*/ siteCode == $config.SITECODE_OGAUC ? $t("MPAY-02-01-12-22") : $t("MPAY-04-01-06-A14") }}</dt>
          <dd class="right">{{ detailInfo.draweRefCtnt1 }}</dd>
          <template v-if="siteCode == $config.SITECODE_OGAUC">
            <dt>{{ /*Code*/ $t("MPAY-04-01-10-13") }}</dt>
            <dd class="right">{{ detailInfo.draweRefCtnt2 }}</dd>
            <dt>{{ /*Reference*/ $t("MPAY-02-01-12-21") }}</dt>
            <dd class="right">{{ detailInfo.draweRefCtnt3 }}</dd>
          </template>
        </dl>
      </template>
      <template #footer>
        <button
          class="btn bottom positive"
          @click="popupClose()"
        >{{ /*확인*/ $t("MPAY-04-01-12-19") }}</button>
      </template>
    </popup>
  </section>
</template>
<script>
import { mapFields } from "vuex-map-fields";

export default {
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
    detailInfo: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapFields(["siteCode", "operGroupCd"]),
    openData: {
      get() {
        return this.opened;
      },
      set(value) {
        this.$emit("update:opened", value);
      },
    },
  },
  methods: {
    popupClose() {
      this.openData = false;
      this.$emit("popupClose", false);
    },
  },
};
</script>
